import React, { Component } from 'react';

class Select extends Component {
    render() {
        return (
            <div className="pp-graph">
                <p>I'm a graph</p>
            </div>
        );
    }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Graph.js